import {useState} from 'react';

import {
  FrontWindow,
  globalDocument,
  globalWindow,
} from '../../../libs/shared/helpers/src/browser/browserHelpers';
import {useInitialEffect} from '../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {useLayer} from '../../../libs/shared/ui/src/components/layers/layerContext';

export function useIsFocused() {
  const layerWindow = useLayer().window;
  const [focused, setFocused] = useState(layerWindow.document.hasFocus());

  useWindowFocusChange(layerWindow, setFocused);

  return focused;
}

export function useWindowFocusChange(window: FrontWindow, onFocusChange: HandlerOf<boolean>) {
  useInitialEffect(() => {
    const onFocus = () => onFocusChange(true);
    const onBlur = () => onFocusChange(false);

    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  });
}

export function useDocumentVisible() {
  const [visible, setVisible] = useState(() => !globalDocument.hidden);

  useInitialEffect(() => {
    function onChange() {
      setVisible(() => !globalDocument.hidden);
    }

    onChange();

    globalWindow.addEventListener('visibilitychange', onChange);
    return () => globalWindow.removeEventListener('visibilitychange', onChange);
  });

  return visible;
}
